// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"850":"d465e0d8","2004":"d465e0d8","3469":"06668d24","5286":"f7c830e4","5438":"06668d24","6704":"5eec7e4f"}[chunkId] + ".chunk.css";
};